import IconBillsGradient, {
	IconBillsGradientProps as _IconBillsGradientProps,
} from './IconBillsGradient';

export { IconBillsGradient };
export type IconBillsGradientProps = _IconBillsGradientProps;
